import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Media,
  Form,
  FormGroup,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import LinesEllipsis from "react-lines-ellipsis";
import {
  aggregationClicked,
  checkAllAggregations
} from "../../actions/searchActions";

import xImg from "../../images/xImage.png";

import classes from "./AggregationsBoxes.module.scss";

class AggregationsBoxes extends Component {
  state = {
    aggregations: [],
    selectedAggregations: this.props.selectedAggregations
  };

  static getDerivedStateFromProps(props, state) {
    let newAggregations = null;
    let aggChanged = false;
    if (
      props.aggregations != null &&
      state.aggregations !== props.aggregations
    ) {
      newAggregations = props.aggregations;
      aggChanged = true;
    }
    let newSelectedAggregations = null;
    let selectedAggChanged = false;
    if (props.selectedAggregations >= 0) {
      newSelectedAggregations = props.selectedAggregations;
      selectedAggChanged = true;
    }
    if (selectedAggChanged || aggChanged) {
      return {
        ...state,
        aggregations: newAggregations,
        selectedAggregations: newSelectedAggregations
      };
    }
    return null;
  }

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <Form inline>
              {this.state.aggregations.map(agg => {
                return agg.checked ? (
                  <div>
                    <FormGroup
                      className={classes.aggregationDiv}
                      id={"tooltip" + agg.id}
                    >
                      <Button
                        color="link"
                        onClick={() =>
                          this.props.aggregationClick(agg.id, false)
                        }
                      >
                        <Media
                          src={xImg}
                          alt="סגור"
                          className={classes.closeImg}
                        />
                      </Button>
                      <LinesEllipsis
                        maxLine="1"
                        text={agg.name}
                        className={classes.aggregationText}
                        component="span"
                      />
                    </FormGroup>
                    <UncontrolledTooltip
                      innerClassName={classes.aggregationTextTooltip}
                      placement="bottom"
                      target={"tooltip" + agg.id}
                    >
                      {agg.name}
                    </UncontrolledTooltip>
                  </div>
                ) : (
                  ""
                );
              })}
              {this.state.selectedAggregations > 0 ? (
                <Button
                  className={classes.resetButton}
                  color="link"
                  onClick={() => {
                    this.props.checkAllClick();
                  }}
                >
                  איפוס
                </Button>
              ) : (
                ""
              )}
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    aggregations: state.searchData.aggregations,
    selectedAggregations: state.searchData.selectedAggregations
  };
};

const mapDispatchToProps = dispatch => {
  return {
    aggregationClick: (id, checked) =>
      dispatch(aggregationClicked(id, checked)),
    checkAllClick: () => dispatch(checkAllAggregations(false))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AggregationsBoxes);
